import { formatIDR } from "@/lib/currency";

// Green-accented price. Shows a clear notice for invalid prices.
export function PriceDisplay({ price, className = "", size = "md", testId }) {
  const formatted = formatIDR(price);
  const sizeMap = {
    sm: "text-base font-bold",
    md: "text-xl font-extrabold",
    lg: "text-2xl sm:text-3xl font-extrabold",
  };
  if (!formatted) {
    return (
      <span data-testid={testId} className={`${sizeMap[size]} text-nm-muted ${className}`}>
        Harga belum tersedia
      </span>
    );
  }
  return (
    <span data-testid={testId} className={`${sizeMap[size]} text-nm-green tracking-tight ${className}`}>
      {formatted}
    </span>
  );
}
